import { useEffect, useState } from 'react';
// import { mockGenerateData } from '../data/mockData';
import type { GenerateApiRequest, GenerateData } from '../types';
import { getAUBaseUrl, getAuthHeader } from '../utils';

const useGenerateApi = (
  clientId: string,
  requestData: GenerateApiRequest,
): {
  message?: string;
  loading: boolean;
  error?: Error;
  onSubmit: (text: string) => void;
  onUpdate: (text: string) => void;
  clearMessage: () => void;
} => {
  const [message, setMessage] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>();
  const [requestBody, setRequestBody] = useState<GenerateApiRequest>(requestData);

  /* eslint-disable no-console */
  useEffect((): void => {
    if (!clientId || !loading) return;
    /* eslint-disable no-console */
    fetch(`${getAUBaseUrl()}/api/generate-response?businessId=${clientId}`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(requestBody),
    })
      .then(response => {
        if (!response?.ok) throw new Error(response.status.toString());
        return response.json();
      })
      .then((data: GenerateData) => setMessage(data.response))
      .catch((error: Error) => {
        console.log('Failed to fetch generated data:', error.message);
        // if (!requestBody.previousMessage) {
        //   setMessage(mockGenerateData.response);
        // } else {
        //   setMessage(
        //     `This is an updated response based on the previously generated message (${requestBody.previousMessage})`,
        //   );
        // }
        setError(error);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, requestBody]);

  const onSubmit = (text: string): void => {
    setLoading(true);
    setRequestBody({ ...requestData, instructions: text });
  };
  const onUpdate = (text: string): void => {
    setLoading(true);
    setRequestBody({
      ...requestData,
      previousMessage: message,
      instructions: text,
    });
  };
  const clearMessage = (): void => {
    setMessage(undefined);
  };

  return { message, loading, error, onSubmit, onUpdate, clearMessage };
};

export default useGenerateApi;
